import React from "react";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setReorderIds } from "src/store/community/categoriesSlice";

import DrawerRight from "src/componets/DrawerRight";
import Tabs from "src/componets/Tabs";
import Reorder from "./_partials/_Reorder";
import CategoriesSettings from "./_partials/_Settings";

const Settings = () => {
  const dispatch = useAppDispatch();
  const reorderIds = useAppSelector(state => state.community.categories.reorderIds);

  function onClose() {
    dispatch(setReorderIds({ ids: null }));
  }

  return (
    <DrawerRight
      open={!!reorderIds}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <h6 className="v-content-label">Choose Option</h6>

      <Tabs
        defaultActiveKey='tab-settings'
        items={[
          { label: 'Settings', key: 'tab-settings', children: <CategoriesSettings /> },
          { label: 'Reorder', key: 'tab-reorder', children: <Reorder /> },
        ]}
      />
    </DrawerRight>
  )
}

export default Settings;
